import * as  TYPE from "./actionTypes"

const initialState = {
  note_cnt: 5,
  menu: '',
  token: {}
}

const Client = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.LOGIN:
      state = {
        note_cnt: action.note_cnt,
        menu: action.menu,
        token: action.token
      }
      break
    
    case TYPE.NEW_TOKEN:
      return {
        ...state,
        token: {
          ...state.token,
          access_token: action.new_token
        }
      };
    
    case TYPE.NOTE_COUNT:
      return {
        ...state,
        note_cnt: action.note_cnt
      };
    
    case TYPE.MENU:
      return {
        ...state,
        menu: action.menu
      };
    
    default:
      state = state
      break
  }
  return state
}

export default Client
